// https://www.figma.com/file/qRzFFgT4Fy8p9GpUmV0g5E/Apollo-Foundation?node-id=2609%3A65767
const baseColours = {
  gray: {
    0: '#FFFFFF',
    50: '#F8F9FA',
    100: '#F3F4F6',
    200: '#EEEFF3',
    300: '#EAEBEF',
    400: '#E1E2E8',
    500: '#999BA8',
    600: '#6A6D7D',
    700: '#3C3847',
    800: '#363240',
    900: '#302D3B',
    1000: '#292632',
    1100: '#201E29',
    1200: '#18161F',
  },
  purple: {
    50: '#F4F2FF',
    100: '#EBE5FF',
    200: '#DDD1FF',
    300: '#C3ADFF',
    400: '#A480FF',
    500: '#8857FA',
    600: '#793EF7',
    700: '#6923F4',
    800: '#4D1AB2',
    900: '#330D80',
  },
  orange: {
    50: '#FEF7F3',
    100: '#FEEDE4',
    200: '#FFDCCC',
    300: '#FFBDA8',
    400: '#F99170',
    500: '#F76D43',
    600: '#F44E27',
    700: '#CC4121',
    800: '#A6361A',
    900: '#7A2714',
  },
  green: {
    50: '#EBFFF8',
    100: '#C4FFED',
    200: '#74FBD0',
    300: '#52EBBA',
    400: '#4AD4A8',
    500: '#37B88F',
    600: '#2E9977',
    700: '#24785D',
    800: '#1D614B',
    900: '#154737',
  },
  yellow: {
    50: '#FBFFE5',
    100: '#F3FEBB',
    200: '#ECFD91',
    300: '#DCE967',
    400: '#C6CC4E',
    500: '#ADAB20',
    600: '#9E9828',
    700: '#8A8220',
    800: '#726916',
    900: '#5C5002',
  },
  pink: {
    50: '#FFF0FE',
    100: '#FFD9FB',
    200: '#FFB8F9',
    300: '#FF8DF4',
    400: '#F26DDC',
    500: '#E550C8',
    600: '#CC3399',
    700: '#BF1D7B',
    800: '#990F54',
    900: '#730B3F',
  },
  red: {
    50: '#FEF7F3',
    100: '#FED9D5',
    200: '#FEC5BE',
    300: '#FF9387',
    400: '#F87263',
    500: '#F24F3D',
    600: '#DB321F',
    700: '#C2210F',
    800: '#961305',
    900: '#731409',
  },
};

const colours = {
  foreground: '#ffffff',
  background: '#F8F9FA',
  background2: '#F3F4F6',
  stoke: '#E1E2E8',
  navigation: '#292632',
  primary: {
    default: '#F44E27',
    background: '#FEF6F4',
  },
  secondary: {
    default: '#6923F4',
    background: '#F4F2FF',
    hover: '#4D1AB2',
  },
  text: {
    primary: '#272431',
    secondary: '#6A6D7D',
    reverse: '#FFFFFF',
    warning: '#C2210F',
    action: '#6923F4',
  },
  accent: {
    green: '#74FBD0',
    yellow: '#ECFD91',
    pink: '#FF8DF4',
    purple: '#C3ADFF',
  },
  message: {
    positive: {
      default: '#37B88F',
      background: '#C4FFED',
    },
    negative: {
      default: '#DB321F',
      background: '#FED9D5',
    },
    hightlight: {
      default: '#ADAB20',
      background: '#ECFD91',
    },
    information: {
      default: '#6923F4',
      background: '#EBE5FF',
    },
    trivial: {
      default: '#6A6D7D',
      background: '#E5E6EC',
    },
  },
  action: {
    primary: '#6923F4',
    secondary: '#EAEBEF',
    hover: '#4D1AB2',
    disabled: '#F3F4F6',
    warning: {
      default: '#C2210F',
      hover: '#961305',
    },
  },
  status: {
    active: '#37B88F',
    busy: '#DB321F',
    inactive: '#EAEBEF',
  },
  badge: {
    default: '#793EF7',
    positive: '#37B88F',
    hightlight: '#C8CC64',
    negative: '#DB321F',
    trivial: '#999BA8',
  },
};

const darkModeColours = {
  foreground: '#292632',
  background: '#18161F',
  background2: '#201E29',
  stoke: '#6A6D7D',
  navigation: '#292632',
  primary: {
    default: '#F99170',
    background: '#FFFFFF',
  },
  secondary: {
    default: '#C3ADFF',
    background: '#FFFFFF',
    hover: '#A480FF',
  },
  text: {
    primary: '#FFFFFF',
    secondary: '#999BA8',
    reverse: '#292632',
    warning: '#FF9387',
    action: '#C3ADFF',
  },
  message: {
    positive: {
      default: '#52EBBA',
    },
    negative: {
      default: '#FF9387',
    },
    hightlight: {
      default: '#ECFD91',
    },
    information: {
      default: '#C3ADFF',
    },
    trivial: {
      default: '#999BA8',
    },
  },
  action: {
    default: '#C3ADFF',
    hover: '#A480FF',
    disabled: '#363240',
    warning: {
      default: '#FF9387',
      hover: '#F87263',
    },
  },
};

const apolloColours = {
  dm: darkModeColours,
  ...baseColours,
  ...colours,
};

export default apolloColours;
